"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const YoutubeIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.84 4.765s-.156-1.12-.636-1.612c-.608-.648-1.29-.65-1.603-.689C11.362 2.3 8.004 2.3 8.004 2.3h-.008s-3.358 0-5.597.164c-.313.038-.995.041-1.603.689C.316 3.646.16 4.765.16 4.765S0 6.08 0 7.395v1.233c0 1.315.16 2.63.16 2.63s.156 1.12.636 1.613c.608.647 1.408.626 1.764.694 1.28.125 5.44.164 5.44.164s3.362-.006 5.601-.17c.313-.038.995-.041 1.603-.688.48-.493.636-1.613.636-1.613s.16-1.315.16-2.63V7.395c0-1.315-.16-2.63-.16-2.63zm-9.492 5.357V5.556l4.323 2.291-4.323 2.275z",
    clipRule: "evenodd"
  })))
});
YoutubeIcon.displayName = 'YoutubeIcon';
var _default = exports.default = YoutubeIcon;